// Responsive design breakpoints
// export const TABLET_WIDTH = getComputedStyle(document.documentElement)
//   .getPropertyValue("--breakpoint-tablet")
//   .trim();
//
// export const DESKTOP_WIDTH = getComputedStyle(document.documentElement)
//   .getPropertyValue("--breakpoint-desktop")
//   .trim();

//   idk why but the above solution kinda sucked and did not work reliably
export const TABLET_WIDTH = "60rem";
export const DESKTOP_WIDTH = "80rem";

// External links
export const FATTURE_IN_CLOUD_URL = "https://secure.fattureincloud.it/login";
export const TEAM_SYSTEM_STUDIO_HR_URL =
  "https://portal.teamsystemhr.com/000/010CF";
export const TEAM_SYSTEM_DIGITAL_URL =
  "https://app.teamsystemdigital.com/portale/#/login?redirectTo=/";
export const PSP_YOUTUBE_CHANNEL_URL = "https://www.youtube.com/@PSPSTPGmbH";
export const PSP_WEBSITE_URL =
  "https://www.psp-bz.it/it/commercialista-alto-adige.html";
export const FLOWER_URL = "https://app.psp-bz.it/flower";

// What to show when there is no value available
export const NO_VALUE = "-";
export const NUMBERS = "0123456789";
